export enum MensajesUsuario {
	Errorgeneral = 'Estamos presentando dificultades técnicas, por favor intenta nuevamente más tarde.',
  NoDataFound = 'No se encontró información.',
  GuardadoExitoso = 'Se ha guardado exitosamente los cambios.',
  SolicitudEliminada = 'La solicitud ha sido eliminada exitosamente!',
  ExportExcel = 'Para Exportar se debe de seleccionar un estado de Rnt en el filtro y seleccionar minimo 1 campo del exportar'
}
